var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3196_80076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4999 4.77431V21.6C21.4999 22.9255 20.4254 24 19.0999 24H5.9C4.57452 24 3.5 22.9255 3.5 21.6V2.4C3.5 1.07452 4.57452 0 5.9 0H16.302L21.4999 4.77431Z",
    fill: "url(#paint0_linear_3196_80076)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48884 18.4601C9.18484 18.4601 8.94084 18.3721 8.75684 18.1961C8.57284 18.0121 8.48084 17.7881 8.48084 17.5241C8.48084 17.2601 8.57284 17.0401 8.75684 16.8641C8.94084 16.6801 9.18484 16.5881 9.48884 16.5881C9.77684 16.5881 10.0128 16.6801 10.1968 16.8641C10.3808 17.0401 10.4728 17.2601 10.4728 17.5241C10.4728 17.7881 10.3808 18.0121 10.1968 18.1961C10.0128 18.3721 9.77684 18.4601 9.48884 18.4601ZM12.5123 18.4601C12.2083 18.4601 11.9643 18.3721 11.7803 18.1961C11.5963 18.0121 11.5043 17.7881 11.5043 17.5241C11.5043 17.2601 11.5963 17.0401 11.7803 16.8641C11.9643 16.6801 12.2083 16.5881 12.5123 16.5881C12.8003 16.5881 13.0363 16.6801 13.2203 16.8641C13.4043 17.0401 13.4963 17.2601 13.4963 17.5241C13.4963 17.7881 13.4043 18.0121 13.2203 18.1961C13.0363 18.3721 12.8003 18.4601 12.5123 18.4601ZM15.5357 18.4601C15.2317 18.4601 14.9877 18.3721 14.8037 18.1961C14.6197 18.0121 14.5277 17.7881 14.5277 17.5241C14.5277 17.2601 14.6197 17.0401 14.8037 16.8641C14.9877 16.6801 15.2317 16.5881 15.5357 16.5881C15.8237 16.5881 16.0597 16.6801 16.2437 16.8641C16.4277 17.0401 16.5197 17.2601 16.5197 17.5241C16.5197 17.7881 16.4277 18.0121 16.2437 18.1961C16.0597 18.3721 15.8237 18.4601 15.5357 18.4601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3196_80076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4996 4.77431H16.9018C16.5704 4.77431 16.3018 4.50568 16.3018 4.17431V0L21.4996 4.77431Z",
    fill: "#CDAFE3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3196_80076",
    x: 14.5018,
    y: -0.6,
    width: 7.59824,
    height: 7.17441,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.6,
    dy: 0.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3196_80076"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3196_80076",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3196_80076",
    x1: 19,
    y1: 2,
    x2: 4,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B180D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833CB9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3196_80076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonFile);
export default __webpack_public_path__ + "static/media/commonFile.960fd44356d04558287a6b437a2987bf.svg";
export { ForwardRef as ReactComponent };